import { render, staticRenderFns } from "./artistic-concept.vue?vue&type=template&id=b4078d68&lang=pug&"
import script from "./artistic-concept.vue?vue&type=script&lang=js&"
export * from "./artistic-concept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/udo/Projects/nakami/gvl/gvl-neustart/gvl-neustart-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4078d68')) {
      api.createRecord('b4078d68', component.options)
    } else {
      api.reload('b4078d68', component.options)
    }
    module.hot.accept("./artistic-concept.vue?vue&type=template&id=b4078d68&lang=pug&", function () {
      api.rerender('b4078d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/artistic-concept.vue"
export default component.exports